import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=5ef143e0&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=5ef143e0&prod&scoped=true&lang=scss"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=5ef143e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef143e0",
  null
  
)

export default component.exports